import React, { useState } from 'react';
import { CalendarIcon, PhoneIcon, ClockIcon, CheckCircleIcon, ArrowRightIcon, SearchIcon, BarChartIcon, TargetIcon } from 'lucide-react';
export function ContactSection() {
  const [showCalendly, setShowCalendly] = useState(false);
  return <section id="contact" className="py-20 bg-gray-50" data-id="element-52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-54">
          <div data-id="element-55">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900" data-id="element-56">
              Ready to Grow Your Business?
            </h2>
            <p className="mt-4 text-xl text-gray-600" data-id="element-57">
              Book your free strategy call today. We'll discuss your business
              goals and show you exactly how our Facebook ad campaigns can help
              you reach them.
            </p>
            <div className="mt-8 space-y-6" data-id="element-58">
              <div className="flex items-start" data-id="element-59">
                <div className="flex-shrink-0" data-id="element-60">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-navy-100 text-navy-800" data-id="element-61">
                    <CalendarIcon className="h-6 w-6" data-id="element-62" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-63">
                  <h3 className="text-lg font-bold text-navy-900" data-id="element-64">
                    Free Strategy Call
                  </h3>
                  <p className="mt-1 text-gray-600" data-id="element-65">
                    No pressure, just a conversation about how we can help your
                    business grow.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-66">
                <div className="flex-shrink-0" data-id="element-67">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-navy-100 text-navy-800" data-id="element-68">
                    <PhoneIcon className="h-6 w-6" data-id="element-69" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-70">
                  <h3 className="text-lg font-bold text-navy-900" data-id="element-71">
                    Expert Guidance
                  </h3>
                  <p className="mt-1 text-gray-600" data-id="element-72">
                    Speak directly with a Facebook ads specialist who
                    understands your industry.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-73">
                <div className="flex-shrink-0" data-id="element-74">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-navy-100 text-navy-800" data-id="element-75">
                    <ClockIcon className="h-6 w-6" data-id="element-76" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-77">
                  <h3 className="text-lg font-bold text-navy-900" data-id="element-78">
                    Quick Response
                  </h3>
                  <p className="mt-1 text-gray-600" data-id="element-79">
                    We'll contact you within 24 hours to schedule your
                    consultation.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-md border border-gray-100" data-id="element-80">
            <div className="flex items-center justify-between mb-6" data-id="element-81">
              <h3 className="text-2xl font-bold text-navy-900" data-id="element-82">
                Book Your Free Strategy Call
              </h3>
              <div className="flex items-center" data-id="element-83">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-84">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-1.5" data-id="element-85"></span>
                  Available Now
                </span>
              </div>
            </div>
            {!showCalendly ? <>
                <div className="bg-navy-50 rounded-lg p-5 mb-6" data-id="element-86">
                  <h4 className="font-semibold text-navy-900 mb-3 flex items-center" data-id="element-87">
                    <span className="flex items-center justify-center w-6 h-6 rounded-full bg-navy-800 text-white text-xs mr-2" data-id="element-88">
                      1
                    </span>
                    Choose a convenient time
                  </h4>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-89">
                    Our calendar shows real-time availability. Select a time
                    that works for your schedule.
                  </p>
                  <button onClick={() => setShowCalendly(true)} className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-navy-800 hover:bg-navy-700 focus:outline-none transition-all duration-300 hover:scale-105" data-id="element-90">
                    View Available Times{' '}
                    <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-91" />
                  </button>
                </div>
                {/* What to Expect - 3-step visual guide */}
                <div className="bg-gray-50 p-5 rounded-lg mb-6" data-id="element-92">
                  <h4 className="font-bold text-navy-900 mb-4 text-center" data-id="element-93">
                    What to Expect
                  </h4>
                  <div className="space-y-4" data-id="element-94">
                    <div className="flex items-start bg-white p-4 rounded-lg border border-gray-200 transition-all duration-300 hover:shadow-md" data-id="element-95">
                      <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-navy-600 text-white mr-3" data-id="element-96">
                        <span className="font-bold" data-id="element-97">1</span>
                      </div>
                      <div data-id="element-98">
                        <h5 className="font-semibold text-navy-900" data-id="element-99">
                          Discovery
                        </h5>
                        <p className="text-sm text-gray-600" data-id="element-100">
                          Tell us about your goals
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start bg-white p-4 rounded-lg border border-gray-200 transition-all duration-300 hover:shadow-md" data-id="element-101">
                      <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-navy-600 text-white mr-3" data-id="element-102">
                        <span className="font-bold" data-id="element-103">2</span>
                      </div>
                      <div data-id="element-104">
                        <h5 className="font-semibold text-navy-900" data-id="element-105">Audit</h5>
                        <p className="text-sm text-gray-600" data-id="element-106">
                          We review your current marketing
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start bg-white p-4 rounded-lg border border-gray-200 transition-all duration-300 hover:shadow-md" data-id="element-107">
                      <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-navy-600 text-white mr-3" data-id="element-108">
                        <span className="font-bold" data-id="element-109">3</span>
                      </div>
                      <div data-id="element-110">
                        <h5 className="font-semibold text-navy-900" data-id="element-111">
                          Strategy
                        </h5>
                        <p className="text-sm text-gray-600" data-id="element-112">
                          You get a custom game plan
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Icon-based checklist */}
                <div className="bg-navy-50 p-4 rounded-lg" data-id="element-113">
                  <h4 className="font-bold text-navy-900 mb-3" data-id="element-114">
                    Your Call Includes:
                  </h4>
                  <div className="grid grid-cols-2 gap-3" data-id="element-115">
                    <div className="flex items-start" data-id="element-116">
                      <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" data-id="element-117" />
                      <span className="text-sm text-gray-700" data-id="element-118">
                        Ad Strategy Breakdown
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-119">
                      <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" data-id="element-120" />
                      <span className="text-sm text-gray-700" data-id="element-121">
                        Audience Targeting Tips
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-122">
                      <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" data-id="element-123" />
                      <span className="text-sm text-gray-700" data-id="element-124">
                        Budget Efficiency Advice
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-125">
                      <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" data-id="element-126" />
                      <span className="text-sm text-gray-700" data-id="element-127">
                        100% Free, Zero Pressure
                      </span>
                    </div>
                  </div>
                </div>
              </> : <div className="calendly-embed" style={{
            height: '600px'
          }} data-id="element-128">
                <iframe src="https://calendly.com/szulcaleks07/free-strategy-call?embed_domain=yourwebsite.com&embed_type=Inline" width="100%" height="100%" frameBorder="0" data-id="element-129"></iframe>
                <button onClick={() => setShowCalendly(false)} className="mt-4 w-full flex justify-center items-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none transition-all duration-300" data-id="element-130">
                  Go Back
                </button>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}